/**
 * Lazy-loaded search components for better performance
 * Heavy chart components are split into separate bundles
 */

import { lazy } from 'react';

// Heavy chart components - lazy loaded
export const CompetitiveBubbleChart = lazy(() => 
  import('./CompetitiveBubbleChart').then(mod => ({ default: mod.default }))
);

export const SearchTimeline = lazy(() =>
  import('./SearchTimeline').then(mod => ({ default: mod.default }))
);

export const MarketAnalysis = lazy(() =>
  import('./MarketAnalysis').then(mod => ({ default: mod.default }))
);

export const MarketConcentration = lazy(() =>
  import('./MarketConcentration').then(mod => ({ default: mod.default }))
);

export const CompetitiveIntensity = lazy(() =>
  import('./CompetitiveIntensity').then(mod => ({ default: mod.default }))
);

export const AppAgeDistribution = lazy(() =>
  import('./AppAgeDistribution').then(mod => ({ default: mod.default }))
);

export const NewEntrants = lazy(() =>
  import('./NewEntrants').then(mod => ({ default: mod.default }))
);

